export const REGION_LABELS = {
  "01": "Астана",
  "02": "Алматы",
  "03": "Акмолинская",
  "04": "Актюбинская",
  "05": "Алматинская",
  "06": "Атырауская",
  "07": "Западно-Казахстанская",
  "08": "Жамбылская",
  "09": "Карагандинская",
  10: "Костанайская",
  11: "Кызылординская",
  12: "Мангистауская",
  13: "Туркестанская",
  14: "Павлодарская",
  15: "Северо-Казахстанская",
  16: "Восточно-Казахстанская",
  17: "Шымкент",
  18: "Абайская",
  19: "Жетысуская",
  20: "Улытауская",
};

export function getRegionLabel(code) {
  if (!code) return "";
  return REGION_LABELS[code] || code;
}
